import React from 'react';

const GuidancePanel = ({ title = "How to Use", children }) => {
  return (
    <div className="bg-black/10 rounded-lg p-8 w-fit">
      <h3 className="text-sky-400 font-medium text-base mb-3">{title}</h3>
      <ul className="space-y-2 text-sm text-zinc-300">
        {children}
      </ul>
    </div>
  );
};

// Bullet item component for consistent styling
export const GuidanceBullet = ({ children }) => (
  <li className="flex items-start">
    <span className="text-sky-400 mr-2">•</span>
    <span>{children}</span>
  </li>
);

export default GuidancePanel; 